import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';
import ReactAutocomplete from 'react-autocomplete';

export const ModelSearch = ({
  model,
  searchSrc,
  closeSrc,
  closeSearch,
  searchPlaceholder,
  setOption,
  filterOption,
  options,
  selectedOptions,
  search,
  filteredOptions,
  removeOption,
  selectedOptionStyle,
  searchBarStyle,
  searchMenuVisibility,
  menuOpen,
  openDropdown,
}) => (
  <div className={styles.modelSearchContainer}>
    <div className={styles.modelSearch}>
      <img src={searchSrc} alt="" className={styles.searchIcon} />
      <ReactAutocomplete
        placeholder={searchPlaceholder}
        getItemValue={item => item.id}
        items={filteredOptions}
        renderItem={item => (
          <div className={styles.option}>
            {item.code} {item.description}
          </div>
        )}
        onMenuVisibilityChange={searchMenuVisibility}
        open={menuOpen}
        value={search}
        onChange={filterOption}
        onSelect={setOption}
        wrapperProps={{
          style: {
            width: '100%',
            marginTop: '1em',
          },
        }}
        inputProps={{
          style: searchBarStyle,
          placeholder: searchPlaceholder,
          onClick: openDropdown,
        }}
        menuStyle={{
          borderRadius: '3px',
          boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
          background: 'rgba(255, 255, 255, 1)',
          padding: '2px 0',
          fontSize: '90%',
          position: 'fixed',
          overflow: 'auto',
          maxHeight: '50%',
          zIndex: 100,
        }}
      />
      <img
        src={closeSrc}
        alt=""
        onClick={closeSearch}
        className={styles.searchClose}
      />
    </div>
    <div className={styles.selectedOptions}>
      {selectedOptions.map(selectedOption => (
        <div
          className={styles.selectedOption}
          style={selectedOptionStyle}
          key={selectedOption.id}
          onClick={() => removeOption(selectedOption.id)}
        >
          {`${selectedOption.code} ${selectedOption.description} X`}
        </div>
      ))}
    </div>
  </div>
);

export default enhance(ModelSearch);
